import { createMedia } from "@artsy/fresnel";
import React, {useContext} from 'react'
import { Icon, Menu } from "semantic-ui-react";
import { Link } from 'react-router-dom';
import Logout from '../Logout';
import gridsec_logo_white from '../../images/gridsec_logo_white.svg'

import UserProfile from '../UserProfile/UserProfile';

import UserContext from '../../contexts/UserContext';

export const AppMedia = createMedia({
    breakpoints: {
        mobile: 320,
        tablet: 768,
        computer: 992,
        largeScreen: 1200,
        widescreen: 1920
        }
    });

export const leftItems = [
        { as: Link, content: "Dashboard", key: "/", to:'/' }
    ];


export const NavBarCustomerItems=(props)=> {
    const { onToggle } = props;
    const userContext = useContext(UserContext)
    


    return (
            <Menu inverted vertical className='customer-sidebar left fixed'>
                <Menu.Item  onClick={onToggle}  as={Link} to='/' className='dashboard-logo-container'>
                    <img alt = 'gridsec_logo_white' src={gridsec_logo_white} className='dashboard-logo'/>
                </Menu.Item>
                <Menu.Item  onClick={onToggle} as={Link} to='/' name='dashboard'>
                    <Icon name='grid layout' />
                    Dashboard
                </Menu.Item>
                <Menu.Item>
                    <Menu.Header className="inverted">Services</Menu.Header>
                    <Menu.Menu>
                        <Menu.Item onClick={onToggle} as={Link} to='/tickets' name='tickets'>
                            Tickets
                        </Menu.Item>
                    </Menu.Menu>
                    {userContext.userInfo.teams.includes("CPUC") ?
                        <Menu.Menu>
                            <Menu.Item  onClick={onToggle}  as={Link} to='/cpuc' name='cpuc'>
                                CPUC
                            </Menu.Item>
                        </Menu.Menu>
                        : null
                    }
                    {userContext.userInfo.teams.includes('NRI')?
                    <Menu.Menu>
                            <Menu.Item  onClick={onToggle} as={Link} to='/energyintegration' name="energy">
                                NRI
                            </Menu.Item>
                    </Menu.Menu>
                    : null
                    }
                    {userContext.userInfo.teams.includes('GridSME')?
                    <Menu.Menu>
                        <Menu.Item  onClick={onToggle} as={Link} to='/invoice' name="invoice">
                            Invoices
                        </Menu.Item>
                    </Menu.Menu>
                    : null
                    }
                    {/* {userContext.userInfo.teams.includes('GridSME') || userContext.userInfo.teams.includes('GridSec') ?
                    <Menu.Menu>
                            <Menu.Item  onClick={onToggle}  as={Link} to='/contacts' name='contacts'>
                            Contact Information
                            </Menu.Item>
                    </Menu.Menu>
                    : null} */}
                    <Menu.Menu>
                        <Menu.Item  onClick={onToggle} id="grid-launch" name='gridKO' as={Link} to='/gridknowledge'>
                            Knowledge Base
                        </Menu.Item>
                    </Menu.Menu>
                    <UserProfile/>
                    {userContext.userInfo.teams.includes('GridSec')?
                        <Menu.Menu>
                            <Menu.Item  as={Link} to='/'  name='admin' onClick={()=> userContext.setAdmin(true)}>
                            Admin
                            </Menu.Item>
                        </Menu.Menu>
                        :       
                        null
                    }
                    
                </Menu.Item>
                <Menu.Menu className='bottom-logout-button'>
                    <Menu.Item>
                        <Logout/>    
                    </Menu.Item>
                </Menu.Menu>
                </Menu>

    )
}


export const NavBarAdminItems=()=> {
    const userContext = useContext(UserContext)

    return (
        <Menu vertical inverted className='admin-sidebar left fixed'>
            <Menu.Item  as={Link} to='/' className='dashboard-logo-container'>
                    <img alt='gridsec_logo_white' src={gridsec_logo_white} className='dashboard-logo' />
                </Menu.Item>
                <Menu.Item as={Link} to='/' name='dashboard'>
                    <Icon name='grid layout' />
                    Dashboard
                </Menu.Item>
                <Menu.Item>
                    <Menu.Header className="inverted">Services</Menu.Header>
                        <Menu.Menu>
                            <Menu.Item as={Link} to='/admin/auvik'  name="auvik" >
                                Auvik
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Menu>
                            <Menu.Item as={Link} to='/admin/ninjaone'  name="ninjaone" >
                                NinjaOne
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Menu>
                            <Menu.Item as={Link} to='/admin/network'name='network'>
                                Network Sheet
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Menu>
                            <Menu.Item  as={Link} to='/admin/reportbuilder' name="reportbuilder" >
                                ReportBuilder
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Menu>
                            <Menu.Item as={Link} to='/admin/bulletin'  name="bulletin">
                                Bulletin
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Menu>
                            <Menu.Item as={Link} to='/admin/portaladmin'  name="portaladmin">
                                Portal Admin
                            </Menu.Item>
                        </Menu.Menu>
                        <Menu.Menu>
                            <Menu.Item as={Link} to='/admin/tickets'  name="tickets" >
                                Tickets
                            </Menu.Item>
                        </Menu.Menu>
                        {/* <Menu.Menu>
                            <Menu.Item  as={Link} to='/admin/tasks' name="tasks">
                                Tasks
                            </Menu.Item>
                        </Menu.Menu> */}
                        <Menu.Menu>
                            <Menu.Item  as={Link} to='/admin/cipevidence' name="cipevidence" >
                                CIP Evidence
                            </Menu.Item>
                        </Menu.Menu>
                    <Menu.Menu>
                        <Menu.Item  as={Link} to='/admin/email' name="email" >
                            Emails
                        </Menu.Item>
                    </Menu.Menu>
                    <Menu.Menu>
                        <Menu.Item  as={Link} to='/'name='admin' onClick={()=> userContext.setAdmin(false)}>
                            Customer
                        </Menu.Item>
                    </Menu.Menu>
                </Menu.Item>
                <Menu.Menu className='bottom-logout-button'>
                    <Menu.Item>
                        <Logout/>    
                    </Menu.Item>
                </Menu.Menu>
                </Menu>
    )
}
